/**
 * Validates a user-provided email address before submitting reservations.
 * @param email Email string from the booking form.
 * @returns `true` when the value matches the widget email pattern.
 */
export function ValidateEmail(email: string) {
  var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

  if (email.match(validRegex)) {
    return true;
  } else {
    return false;
  }
}

/**
 * Creates an isolated shadow root so host-page styles cannot leak into widget UI.
 * @param root Host element where the shadow container gets attached.
 * @returns Open `ShadowRoot` instance used for rendering.
 */
export function createShadow(root: any) {
  const div = document.createElement('div');
  const style = document.createElement('style');
  style.innerHTML = ':host { all: initial; }';
  const shadow = div.attachShadow({ mode: 'open' });
  shadow.appendChild(style);
  root.appendChild(div);
  return shadow;
}

/**
 * Mirrors active element labels to the host for better screen reader context.
 * @param e Native focus event bubbling from inside the shadow root.
 * @returns No return value.
 */
export function shadowRootFocusListener(e: Event) {
  const el = e.target as HTMLElement;
  if (el && el.getAttribute) {
    (document.querySelector('#seminargo-sr-div') as HTMLDivElement)?.click();
    document.querySelector('#seminargo-widget')?.removeAttribute('aria-label');
    if (el.getAttribute('aria-label')) {
      document.querySelector('#seminargo-widget')?.setAttribute('aria-label', el.getAttribute('aria-label') || '');
    }
    (document.querySelector('#seminargo-widget') as HTMLDivElement).click();
  }
}
